import { Item, ItemContent, ItemTitle } from '@nesso/ui/primitives/item';

import type { ClientBalance } from '@/entities/session-charge';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';
import { DotSeparatedText } from '@/shared/ui/text/dot-separated-text';

type Props = {
    balance: ClientBalance | undefined;
};

export function ClientDetailsBillingBalance({ balance }: Props) {
    if (!balance) {
        return (
            <Item variant="muted" size="sm" alignment="center">
                <ItemContent>
                    <ItemTitle>Couldn't load balance</ItemTitle>
                </ItemContent>
            </Item>
        );
    }

    return (
        <DotSeparatedText
            items={[
                `${formatCurrencyFromCents(balance.balanceCents)} balance`,
                balance.creditsCents > 0
                    ? `${formatCurrencyFromCents(balance.creditsCents)} credits`
                    : null,
            ]}
        />
    );
}
